<nav class="left-nav d-flex flex-column align-items-center py-4">
	<div class="w-100 d-flex flex-column align-items-center left-nav-logo">
		<!-- Logo -->
		<div class="mb-4 mt-2">
			<img src="assets/images/left-nav-logo.png" alt="Logo" style="width: 50px; height: auto" />
		</div>
		<!-- Nav Items -->
		<!-- NRI Menu -->
		<ul *ngIf="isNRI()" class="nav flex-column w-100" style="gap: 2px;">
			<li class="nav-item text-center">
				<a class="nav-link py-3" [routerLink]="['/nri/dashboard']" routerLinkActive="active">
					<i class="fa fa-dashboard fa-lg mb-1" aria-hidden="true"></i>
					<div class="small">Dashboard</div>
				</a>
			</li>
			<!-- <li class="nav-item text-center">
				<a class="nav-link py-3" routerLinkActive="active"
				[routerLinkActiveOptions]="{ exact: false }">
					<i class="fa fa-plane" aria-hidden="true"></i>
					<div class="small">Travel</div>
				</a>
			</li>
			<li class="nav-item text-center">
				<a class="nav-link py-3">
					<i class="fa fa-plus" aria-hidden="true"></i>
					<div class="small">Services</div>
				</a>
			</li>
			<li class="nav-item text-center">
				<a class="nav-link py-3">
				<i class="fa fa-globe" aria-hidden="true"></i>
					<div class="small">Marketplace</div>
				</a>
			</li> -->
			<!-- <li class="nav-item text-center">
				<a class="nav-link py-3" routerLink="/collection" routerLinkActive="active">
					<i class="fa fa-folder-open fa-lg mb-1" aria-hidden="true"></i>
					<div class="small">Collection</div>
				</a>
			</li> -->
			<!-- <li class="nav-item text-center">
				<a class="nav-link py-3" routerLink="/discover" routerLinkActive="active">
					<i class="fa fa-compass fa-lg mb-1" aria-hidden="true"></i>
					<div class="small">Discover</div>
				</a>
			</li> -->
		</ul>
		
		<!-- Admin Menu -->
		<ul *ngIf="isAdmin()" class="nav flex-column w-100" style="gap: 2px;">
			<li class="nav-item text-center">
				<a class="nav-link py-3" [routerLink]="['/admin/properties']" routerLinkActive="active">
					<i class="fa fa-building fa-lg mb-1" aria-hidden="true"></i>
					<div class="small">Properties</div>
				</a>
			</li>
			<!-- Add more admin menu items here -->
		</ul>
		
		<!-- Service Provider Menu -->
		<ul *ngIf="isServiceProvider()" class="nav flex-column w-100" style="gap: 2px;">
			<li class="nav-item text-center">
				<a class="nav-link py-3" [routerLink]="['/service-provider/dashboard']" routerLinkActive="active">
					<i class="fa fa-dashboard fa-lg mb-1" aria-hidden="true"></i>
					<div class="small">Dashboard</div>
				</a>
			</li>
			<!-- Add more service provider menu items here -->
		</ul>
	</div>
	<!-- Bottom Section -->
   <div class="mt-auto w-100 d-flex flex-column align-items-center mb-3" style="gap: 24px;">
    <button matButton [matMenuTriggerFor]="menu" class="user-initials-btn">
      <span  class="initials-circle">{{userInfo?.firstName?.charAt(0)}}</span>
    </button>
      <mat-menu #menu="matMenu">
        <!-- <button mat-menu-item routerLink="/nri/my-profile">
          <i class="fa fa-user-plus" aria-hidden="true"></i>
          Profile
        </button> -->
        <button mat-menu-item (click)="logout()">
          <i class="fa fa-sign-out" aria-hidden="true"></i>
          Logout
        </button>
      </mat-menu>
    </div>
	<!-- <div class="mt-auto w-100 d-flex flex-column align-items-center mb-3" style="gap: 24px;">
		<a class="nav-link py-2" routerLink="/invite" routerLinkActive="active">
			<i class="fa fa-user-plus fa-lg" aria-hidden="true"></i>
		</a>
		<a class="nav-link py-2" routerLink="/settings" routerLinkActive="active">
			<i class="fa fa-cog fa-lg" aria-hidden="true"></i>
		</a>
	</div> -->
</nav>
